import { refundMethods } from '@reveni-io/reveni-ui'

export const skippableRefundMethods = [
  refundMethods.originalPaymentMethod,
  refundMethods.storeCredit,
  refundMethods.giftCard,
]
